import React from 'react';

const MonthlyBonus = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.75046 1.49883V3.2482H16.2449V1.49883H17.7442V3.2482H20.9926C21.9587 3.2482 22.7418 4.03133 22.7418 4.99738V18.9908C22.7418 21.0609 21.0637 22.739 18.9936 22.739H5.00019C2.9301 22.739 1.25195 21.0609 1.25195 18.9908V4.99738C1.25195 4.03134 2.03509 3.2482 3.00113 3.2482H6.25117V1.49883H7.75046ZM16.2449 4.74749V6.49647H17.7442V4.74749H20.9926C21.1306 4.74749 21.2425 4.85937 21.2425 4.99738V8.24566H2.75125V4.99738C2.75125 4.85937 2.86312 4.74749 3.00113 4.74749H6.25117V6.49647H7.75046V4.74749H16.2449ZM2.75125 9.74496H21.2425V18.9908C21.2425 20.2328 20.2356 21.2397 18.9936 21.2397H5.00019C3.75813 21.2397 2.75125 20.2328 2.75125 18.9908V9.74496ZM11.2462 11.4938C11.2462 13.2879 9.79177 14.7423 7.99769 14.7423V14.7424V16.2416V16.2417C9.79177 16.2417 11.2462 17.6961 11.2462 19.4901H12.7455V19.4895H12.7461C12.7461 17.7106 14.176 16.2657 15.9491 16.2414L15.9946 16.2416V16.2411V14.7423V14.7418L15.9491 14.742C14.176 14.7177 12.7461 13.2727 12.7461 11.4938H12.7455H11.2468H11.2462Z",
      fill: "white"
    }
  )
);

export { MonthlyBonus };
//# sourceMappingURL=MonthlyBonus.js.map
